import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { ButtonBase, ButtonBaseProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import { Icon } from "@/components/ui-v2/Icon/Icon";

const Root = styled(ButtonBase, {
  shouldForwardProp: (prop: string) =>
    !["isCollapsed", "isDragActive", "isOver", "isSupportingDrop"].includes(
      prop,
    ),
})<{
  isCollapsed?: boolean;
  isDragActive?: boolean;
  isOver?: boolean;
  isSupportingDrop?: boolean;
}>(({ theme, isCollapsed, isDragActive, isOver, isSupportingDrop }) => ({
  width: "100%",
  gap: theme.spacing(2),
  borderRadius: "8px",
  padding: theme.spacing(2),
  backgroundColor: theme.palette.secondary["7/75"],
  backdropFilter: "blur(2px)",
  aspectRatio: isCollapsed ? "auto" : "1/1",
  border: `${isSupportingDrop ? "dashed" : "solid"} 1px ${isDragActive || isOver ? theme.palette.primary.light : theme.palette.secondary["3/25"]}`,
  "&:hover": {
    border: `${isSupportingDrop ? "dashed" : "solid"} 1px ${theme.palette.secondary["3/75"]}`,
  },
}));

const IconContainer = styled("span")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 28,
  height: 28,
  borderRadius: "50%",
  padding: theme.spacing(2),
  border: `1px solid ${theme.palette.secondary[4]}`,
  backgroundColor: theme.palette.secondary[5],

  "&:hover": {
    borderColor: theme.palette.secondary[3],
    backgroundColor: theme.palette.secondary[4],
  },
}));

interface AddToListButtonProps extends ButtonBaseProps {
  isCollapsed?: boolean;
  isDragActive?: boolean;
  isOver?: boolean;
  isSupportingDrop?: boolean;
}

export const AddToListButton = (props: AddToListButtonProps) => {
  const { children, ...rest } = props;

  return (
    <Root {...rest}>
      <IconContainer>
        <Icon icon={faPlus} style={{ minWidth: 14, minHeight: 14 }} />
      </IconContainer>
      {children}
    </Root>
  );
};
